import { type MetaFunction } from '@remix-run/node'

export const meta: MetaFunction = () => [
	{ title: 'Winter Home Maintenance Tips' },
	{
		name: 'description',
		content:
			'What you can do during the winter to prevent insurance claims on your home.',
	},
]

export default function Component() {
	return (
		<>
			<h1 className="py-3 text-4xl font-black">
				Extreme Maintenance: Home Edition - Winter
			</h1>
			<p
				data-paragraph
				className="mt-6 text-xl/7 text-muted-foreground xl:mt-8 xl:text-xl/6 xl:leading-10"
			>
				New Yorkers are not strangers to extreme Winter weather. Freezing
				temperatures, snow, and ice can create hazardous conditions for you and
				your home. It is important to know the risks of such weather and take
				action to prevent damage to you or your property.
			</p>
			<p
				data-paragraph
				className="mt-6 text-xl/7 text-muted-foreground xl:mt-8 xl:text-xl/6 xl:leading-10"
			>
				During winter months, snow and ice can accumulate on the roof causing
				extreme weight to be applied. This can cause a structure collapse, like
				the roof caving in, or the snow could slide off the roof and damage
				whatever it lands on. Large ice formations can dam the water caused by
				melting. The dammed water can then find its way beneath the roof
				material and into your home. Be mindful of the amount of accumulation
				and if necessary, take action to carefully reduce the load that is
				placed on your roof.
			</p>
		</>
	)
}
